// Authenticated binary downloads (PDFs, ZIPs, documents).
// Centralized so there's exactly one place that reads the bearer token.

function getAuthToken() {
  try {
    return localStorage.getItem("rv_token");
  } catch {
    return null;
  }
}

/**
 * Authenticated binary fetch that triggers a browser download.
 * Returns a boolean — true on success, throws on failure so callers can surface UX.
 *
 * @param {string} path - API path (starts with "/api/...") OR absolute URL
 * @param {string} filename - download filename
 * @param {Record<string, string|number>} [params] - optional query string values
 */
export async function authenticatedDownload(path, filename, params) {
  const token = getAuthToken();
  const qs = params ? "?" + new URLSearchParams(params).toString() : "";
  const base = path.startsWith("http") ? path : `${process.env.REACT_APP_BACKEND_URL}${path}`;
  const resp = await fetch(`${base}${qs}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    // credentials: "omit" — Bearer token already in headers. Including
    // cookies would force iOS Safari to reject responses when the backend
    // returns `Access-Control-Allow-Origin: *` (CORS spec forbids `*`
    // with credentialed requests; WebKit enforces this strictly). See the
    // similar fix in /app/frontend/src/lib/api.js.
    credentials: "omit",
  });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  const blob = await resp.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
  return true;
}

// Legacy alias — keep for existing PDF call sites.
export const downloadPdf = authenticatedDownload;
